import { DynamicParams } from '@config/react-router-dom/hooks/query-params.types';

export enum AppLandingConstants {
    name = 'appLanding'
}

export enum AppLandingModalConstants {
    errorHome,
    errorConnection,
    viewportGuide,
    skillQuestsRefresh,
    challengesRefresh,
    assessmentsRefresh,
	downloadMXPaper
}

export enum AppLandingModalTypes {
    route,
    viewport,
    initData,
    assignment,
    restrict,
    course,
    student,
    assignmentCallback,
    assignedActivities,
    navigation
}

export type AppLandingModal = {
    variant: AppLandingModalConstants | null
    type: AppLandingModalTypes | null
};

type AppLandingUser = {
    academicYearEndDate: string | null
    preferredCourseCountyCode: string | null
};

export type AppLandingState = {
    modal: AppLandingModal
    user: AppLandingUser
    dynamicParams: Array<DynamicParams>
};

export const getAppLandingModalDefault = (): AppLandingModal => ({
    variant: null,
    type: null
});
